import React from "react";
import { Link } from "react-router-dom";
import "./Portfolio.css";
import Website from "./Website/Website";

const Portfolio = () => {
  return (
    <div>
      <Website/>

   
      </div>

  );
};

export default Portfolio;
